module.exports = __webpack_public_path__ + "img/flag-SPAIN.ba22df0b.svg";